import { ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Flex, Box, Text } from 'rebass/styled-components'

interface IMenuSelectorProps {
  text: string
  route: string,
  isMinified?: boolean
  count?: number
  alternativeRoutes?:Array<string>
  children?: ReactNode
}
const MenuSelector: React.FC<IMenuSelectorProps> = ({
  text,
  route,
  children,
  isMinified,
  count,
  alternativeRoutes
}) => {
  const location = useLocation()
  const navigate = useNavigate()

  const goToPage = () => {
    navigate(route)
  }
  const isSelected = location && (location.pathname === route || (!!alternativeRoutes && alternativeRoutes.find(x=>location.pathname.startsWith(x))))
  return <Flex flexDirection='row' onClick={goToPage} className={!isSelected?'btnHamburger':''} style={{ width: '100%', position: 'relative', overflow: 'hidden', cursor:'pointer', alignItems: 'center', borderRadius: '10px', marginBottom: '20px', paddingRight: isMinified ? 0 : '6px', paddingTop: '8px', paddingBottom: '8px', background: isSelected ? 'rgba(248, 162, 148, 0.62)' : 'transparent' }}>
    <Box style={{ width: '8px', margin: '-8px 0', marginRight: isMinified ? '8px' : '24px', backgroundColor: isSelected ? '#F6A293' : 'transparent', height: 'calc(100% + 16px)' }} />
    {children}
    {!isMinified &&
      <Text style={{ marginLeft: '16px', color: '#344f79', fontWeight: isSelected ? 500 : 300, flex: 1, fontSize:'14px' }}>{text}</Text>
    }
    {!!count && (
      <>
        {!isMinified ? (
          <Box style={{ background: '#FFD2CA', borderRadius: '5px', padding: '0px 7px' }}>
            <Text fontSize={'13px'}>{count}</Text>
          </Box>
        ) : (
          <Box style={{ position: 'absolute', top: '4px', left: '40px', borderRadius: '50%', height: '12px', width: '12px', background: 'red' }}></Box>
        )}
      </>
    )}
  </Flex>
}

export default MenuSelector